import { render, staticRenderFns } from "./Support6.vue?vue&type=template&id=74521976&scoped=true"
import script from "./Support6.vue?vue&type=script&lang=js"
export * from "./Support6.vue?vue&type=script&lang=js"
import style0 from "./Support6.vue?vue&type=style&index=0&id=74521976&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74521976",
  null
  
)

export default component.exports